import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
const CityField = t0 => {
  const $ = _c(25);
  let error;
  let handleBlur;
  let handleChange;
  let isTouched;
  let props;
  let t1;
  let t2;
  let t3;
  let updateShipping;
  let value;
  if ($[0] !== t0) {
    ({
      id: t1,
      name: t2,
      value,
      error,
      isTouched,
      handleBlur,
      handleChange,
      updateShipping,
      isRequired: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = handleBlur;
    $[3] = handleChange;
    $[4] = isTouched;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = updateShipping;
    $[10] = value;
  } else {
    error = $[1];
    handleBlur = $[2];
    handleChange = $[3];
    isTouched = $[4];
    props = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    updateShipping = $[9];
    value = $[10];
  }
  const id = t1 === undefined ? "city" : t1;
  const name = t2 === undefined ? "city" : t2;
  const isRequired = t3 === undefined ? true : t3;
  let t4;
  if ($[11] !== error || $[12] !== handleBlur || $[13] !== updateShipping) {
    t4 = evt => {
      handleBlur(evt);
      if (!error) {
        updateShipping?.();
      }
    };
    $[11] = error;
    $[12] = handleBlur;
    $[13] = updateShipping;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = isTouched && error ? error : null;
  const t6 = isRequired ? "" : undefined;
  const t7 = isRequired ? "" : undefined;
  let t8;
  if ($[15] !== handleChange || $[16] !== id || $[17] !== name || $[18] !== props || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== value) {
    t8 = <LabeledTextInput id={id} type="text" name={name} label="City *" onChange={handleChange} onBlur={t4} value={value} data-xc="shipping-city-field" autoComplete="address-level2" errorMessage={t5} required={t6} aria-required={t7} {...props} />;
    $[15] = handleChange;
    $[16] = id;
    $[17] = name;
    $[18] = props;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = value;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
CityField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  updateShipping: PropTypes.func,
  value: PropTypes.string
};
export default CityField;